export default class TranslatedObject {
    constructor(field) {
        this.fr=field["fr"];
        this.mg=field["mg"];
        this.en=field["en"];
    }
    toString(){
        return this[TranslatedObject.currentLanguage];
    }
}
TranslatedObject.currentLanguage=null;